import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NetworkStatusService {
    private onlineSubject = new BehaviorSubject<boolean>(navigator.onLine);

    readonly online$: Observable<boolean> = this.onlineSubject.asObservable();

    constructor(private zone: NgZone) {
        window.addEventListener('online', () => this.updateStatus(true));
        window.addEventListener('offline', () => this.updateStatus(false));
    }

    private updateStatus(status: boolean) {
        this.zone.run(() => this.onlineSubject.next(status));
    }

    isOnline(): boolean {
        return this.onlineSubject.value;
    }
}
